import React from 'react';
import './style.scss';

export const ShippingMethodLoader: React.FC = () => {
  return (
    <div className="flex flex-col p-4">
      {[1, 2].map(i => (
        <div
          key={i}
          className="flex justify-between items-center p-4 border rounded-md bg-white">
          {/* Left info */}
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-gray-200 rounded skeleton-shimmer" />
            <div className="flex flex-col">
              {/* Small gap between text lines */}
              <div className="h-4 w-32 bg-gray-200 rounded skeleton-shimmer"></div>
              <div className="h-3 w-24 bg-gray-200 rounded skeleton-shimmer mt-1"></div>
            </div>
          </div>

          {/* Right price */}
          <div className="flex flex-col items-end">
            <div className="h-4 w-16 bg-gray-200 rounded skeleton-shimmer"></div>
            <div className="w-6 h-6 bg-gray-200 rounded-full skeleton-shimmer mt-1"></div>
          </div>
        </div>
      ))}
    </div>
  );
};
